
import { Product } from './types';

export const INITIAL_PRODUCTS: Product[] = []; // On récupère tout de Supabase désormais

export const SOCIALS = {
  instagram: { handle: '@randcessentials_', url: 'https://www.instagram.com/randcessentials_/' },
  snapchat: { handle: '@rakyatou_d', url: 'https://www.snapchat.com/add/rakyatou_d' },
  tiktok: { handle: '@randc_essentials', url: 'https://www.tiktok.com/@randc_essentials' },
  whatsapp: { number: '221775782422', label: '77 578 24 22' }
};

export const INSTAGRAM_POSTS = [
  { 
    url: 'https://www.instagram.com/p/DR3MRIrjEu7/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==', 
    image: 'https://fbaptclwziljpmozftiz.supabase.co/storage/v1/object/public/images/Ambiance.png' 
  },
  { 
    url: 'https://www.instagram.com/p/DPmwPfFjrxn/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==', 
    image: 'https://fbaptclwziljpmozftiz.supabase.co/storage/v1/object/public/images/Commu%20gel.png' 
  },
  { 
    url: 'https://www.instagram.com/p/DOiDDtAjeDZ/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==', 
    image: 'https://fbaptclwziljpmozftiz.supabase.co/storage/v1/object/public/images/Cremes.png' 
  },
  { 
    url: 'https://www.instagram.com/p/DPWowpJjstF/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==', 
    image: 'https://fbaptclwziljpmozftiz.supabase.co/storage/v1/object/public/images/Back2school.png' 
  }
];

export const formatPrice = (price: number) => {
  return price.toLocaleString('fr-FR') + ' FCFA';
};
